export default __webpack_public_path__ + "static/media/coins_display.034b43fe.png";